module.exports = __webpack_public_path__ + "static/img/news_1.78c594e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/news_1.jpg
// module id = J9go
// module chunks = 0